<div class="container">
    <h1 class="page-title">
      <span class="icon"><i class="fas fa-clipboard-list"></i></span>Do 規則維護</h1>
    <p-card>
        <p-accordion>
            <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
                <form [formGroup]="searchForm">
                    <div class="p-fluid formgrid grid">
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>倉別</label>
                            <p-dropdown formControlName="facility" (onChange)="facilityChange($event)" [options]="facilityOptions" [(ngModel)]="searchParams.facility"></p-dropdown>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3"></div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3"></div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>規則分類</label>
                            <p-dropdown formControlName="ruleName" (onChange)="changeSearch($event)" [options]="ruleOptions" [(ngModel)]="searchParams.ruleName"></p-dropdown>
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>車次分類</label>
                            <p-dropdown formControlName="carCategory" (onChange)="changeSearch($event)" [disabled]="searchParams.facility == ''" [options]="carCategoryOptions" [(ngModel)]="searchParams.carCategory"></p-dropdown>
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <!-- <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchClickBtn($event)"></button> -->

                            <button pButton pRipple label="{{ 'Common.Button.Add' | translate }}" class="p-button-info" [disabled]="searchParams.ruleName == ''" (click)="addClickBtn($event)"></button>

                            <button pButton pRipple label="Simulate" class="p-button-help ml-3" (click)="simulateClickBtn($event)"></button>

                            <button pButton pRipple label="Simulate 執行結果" class="p-button-warning ml-3" (click)="simulateResultClickBtn($event)"></button>

                            <button pButton pRipple label="匯入現行規則" class="ml-3" (click)="importRuleClick($event)"></button>
                        </div>
                    </div>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div class="mt-2">
            <p-table #RuleTable laasDataTableSetting [tableKey]="preferenceKey" [defaultColumns]="columns" [value]="ruleResults" class="datatable" [loading]="isLoading" [tailHeaderDefaultWidths]="[50]" styleClass="p-datatable-striped" dataKey="seqNo">
                <ng-template pTemplate="caption">
                  <laas-table-column-toggle
                    [optionsColumn]="columns"
                    [dataTable]="RuleTable">
                  </laas-table-column-toggle>
                </ng-template>
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup>
                        <col *ngFor="let col of columns" [style]="{ width: col.width + 'px' }">
                        <col style="width: 3vw;">
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th [pSortableColumn]="col.field" *ngFor="let col of columns" pResizableColumn pReorderableColumn [attr.field]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                        <th>
                            動作
                        </th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr>
                        <td *ngFor="let col of columns;let i = index;">
                            <div [ngSwitch]="col.field">
                                <ng-container *ngSwitchCase="'orFlag'">
                                    <div class="overflow-text">
                                        {{ (rowData[col.field] == 1 ? "是" : "否") | replaceNullWith:'-'}}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'isDelete'">
                                    <div class="overflow-text">
                                        {{ (rowData[col.field] == 1 ? "是" : "否") | replaceNullWith:'-'}}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'ifFlag'">
                                    <div class="overflow-text">
                                        {{ getIfFlagWording(rowData[col.field], rowData.ruleOrder)}}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'checkType'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | optionsMapping:checkTypeOptions | replaceNullWith:'-'}}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchCase="'operator'">
                                    <div class="overflow-text">
                                        {{ rowData[col.field] | optionsMapping:operatorOptions | replaceNullWith:'-'}}
                                    </div>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <ng-container [ngSwitch]="col.dataType">
                                        <ng-container *ngSwitchCase="'date'">
                                            <div class="overflow-text">
                                                {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                            <div class="overflow-text">
                                                {{ rowData[col.field] | replaceNullWith:'-'}}
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </td>
                        <td>
                            <i class="fas fa-pencil-alt" (click)="editRule($event, rowData)"></i>
                            <i class="fas fa-trash ml-3" (click)="removeRule($event, rowData)"></i>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns.length + 1" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>

    <p-dialog [(visible)]="showModifyDialog" appendTo="body" [style]="{width: '50vw'}" [modal]="true">
        <ng-template pTemplate="header">
            {{(isInsert ? "新增" : "更新")}} Do Rule
        </ng-template>
        <ng-template pTemplate="body">
            <div class="p-fluid formgrid grid ">
                <div class="field col-6">
                    <label>倉別</label>
                    <p-dropdown [options]="facilityOptions" [disabled]="true" [(ngModel)]="modifyObject.facility" appendTo="body" [filter]="true"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>規則分類</label>
                    <p-dropdown [options]="ruleOptions" [disabled]="true" [(ngModel)]="modifyObject.ruleName" appendTo="body"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>車次分類</label>
                    <div>
                        <p-dropdown [options]="carCategoryOptions" [disabled]="true" [(ngModel)]="modifyObject.carCategory" appendTo="body"></p-dropdown>
                    </div>
                </div>
                <div class="field col-6">
                    <label>檢核類型</label>
                    <p-dropdown [options]="checkTypeOptions" [(ngModel)]="modifyObject.checkType" appendTo="body"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>欄位名稱</label>
                    <p-dropdown [options]="doColumnOptions" [(ngModel)]="modifyObject.field" appendTo="body" [filter]="true"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>運算子</label>
                    <p-dropdown [options]="operatorOptions" [(ngModel)]="modifyObject.operator" appendTo="body" [filter]="true"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>值</label>
                    <input type="text" [(ngModel)]="modifyObject.value" pInputText>
                </div>
                <div class="field col-6">
                    <label>RuleOrder</label>
                    <p-inputNumber [(ngModel)]="modifyObject.ruleOrder"></p-inputNumber>
                </div>
                <div class="field col-6">
                    <label>OR Flag</label>
                    <div>
                        <p-checkbox [(ngModel)]="modifyObject.orFlagTmp" [binary]="true"></p-checkbox>
                    </div>
                </div>
                <div class="field col-6">
                    <label>If Flag</label>
                    <div>
                        <p-dropdown [options]="ifFlagOptions" [(ngModel)]="modifyObject.ifFlag" appendTo="body"></p-dropdown>
                    </div>
                </div>
                <div class="field col-12">
                    <label>錯誤訊息</label>
                    <textarea [rows]="5" pInputTextarea [autoResize]="true" [(ngModel)]="modifyObject.failMessage"></textarea>
                </div>
            </div>
            <div class="grid">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="modifyClick($event)"></button>
                </div>
            </div>
        </ng-template>
        <p-footer>

        </p-footer>
    </p-dialog>

    <p-dialog [(visible)]="showSimulateDialog" appendTo="body" [style]="{width: '50vw'}" [modal]="true">
        <ng-template pTemplate="header">
            Simulate
        </ng-template>
        <ng-template pTemplate="body">
            <div class="p-fluid formgrid grid ">
                <!-- <div class="field col-12">
                    <label>ETA 時間</label>
                    <div class="formgrid grid">
                        <div class="col">
                            <p-calendar appendTo="body" dateFormat="yy/mm/dd" [(ngModel)]="simulateParams.etaStartTmp">
                            </p-calendar>
                        </div> ~
                        <div class="col">
                            <p-calendar appendTo="body" dateFormat="yy/mm/dd" [(ngModel)]="simulateParams.etaEndTmp">
                            </p-calendar>
                        </div>
                    </div>
                </div> -->
                <div class="field col-12">
                    <label>ETD 時間</label>
                    <div class="formgrid grid">
                        <div class="col">
                            <p-calendar appendTo="body" dateFormat="yy/mm/dd" [(ngModel)]="simulateParams.etdStartTmp">
                            </p-calendar>
                        </div> ~
                        <div class="col">
                            <p-calendar appendTo="body" dateFormat="yy/mm/dd" [(ngModel)]="simulateParams.etdEndTmp">
                            </p-calendar>
                        </div>
                    </div>
                </div>
                <div class="field col-12">
                    <label>建立時間</label>
                    <div class="formgrid grid">
                        <div class="col">
                            <p-calendar appendTo="body" dateFormat="yy/mm/dd" [(ngModel)]="simulateParams.createDtStartTmp">
                            </p-calendar>
                        </div> ~
                        <div class="col">
                            <p-calendar appendTo="body" dateFormat="yy/mm/dd" [(ngModel)]="simulateParams.createDtEndTmp">
                            </p-calendar>
                        </div>
                    </div>
                </div>
                <div class="field col-12">
                    <label>DO 單號</label>
                    <p-chips [(ngModel)]="simulateParams.doNoList"></p-chips>
                </div>
                <div class="field col-6">
                    <label>倉別</label>
                    <p-dropdown appendTo="body" [options]="facilityOptions" [(ngModel)]="simulateParams.facility"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>Tenant</label>
                    <p-dropdown appendTo="body" [options]="tenantOptions" [(ngModel)]="simulateParams.tenant"></p-dropdown>
                </div>
                <div class="field col-6">
                    <label>是否為出口</label>
                    <div>
                        <p-checkbox [binary]="true" [(ngModel)]="simulateParams.forExportTmp"></p-checkbox>
                    </div>
                </div>
            </div>
            <div class="grid">
                <div class="col">
                    <button pButton pRipple label="{{ 'Common.Button.Save' | translate }}" (click)="simulateSaveClick($event)"></button>
                </div>
            </div>
        </ng-template>
    </p-dialog>
    <p-dialog [(visible)]="showSimulateResultDialog" appendTo="body" [style]="{width: '80vw'}" [modal]="true">
        <ng-template pTemplate="header">
            Simulate 執行結果
        </ng-template>
        <ng-template pTemplate="body">
            <p-table [value]="simulateResults" [rows]="5" [paginator]="true" [rowsPerPageOptions]="[5,10,15,20]" [loading]="isSimulateResultLoading" class="datatable" styleClass="p-datatable-gridlines">
                <ng-template pTemplate="header">
                    <tr>
                        <th>流水號</th>
                        <th>建立起始時間</th>
                        <th>建立結束時間</th>
                        <th>ETD 起始時間</th>
                        <th>ETD 結束時間</th>
                        <th>倉別</th>
                        <th>DO 單號</th>
                        <th>Tenant</th>
                        <th>是否為出口</th>
                        <th>狀態</th>
                        <th>動作</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-simulate>
                    <tr>
                        <td>{{simulate.seqNo}}</td>
                        <td>{{simulate.createDtStart | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</td>
                        <td>{{simulate.createDtEnd | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</td>
                        <td>{{simulate.etdStart | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</td>
                        <td>{{simulate.etdEnd | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}</td>
                        <td>{{simulate.facility | replaceNullWith:'-'}}</td>
                        <td>{{simulate.doNoList | replaceNullWith:'-'}}</td>
                        <td>{{simulate.tenant | replaceNullWith:'-'}}</td>
                        <td>{{(simulate.forExport == 0 ? "否" : "是") | replaceNullWith:'-'}}</td>
                        <td>{{simulate.status | optionsMapping:statusOptions | replaceNullWith:'-'}}</td>
                        <td>
                            <a *ngIf="simulate.status == 'F'" target="_blank" [href]="getSimulateUrl(simulate.seqNo)">
                                <i class="fas fa-eye"></i>
                            </a>
                            <i class="fas fa-save ml-3" (click)="exportRuleClick($event, simulate.seqNo)"></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </ng-template>
    </p-dialog>
</div>
